import { apiClient } from './ApiClient';
import { API_ENDPOINTS } from '../../shared/constants';
import { ApiResponse, VehicleApiData } from '../../shared/types';
import { Vehicle } from '../../domain/entities';

export class VehicleApi {
    static async fetchByPlateOrCard(plateOrCard: string, token: string): Promise<Vehicle | null> {
        const cleanValue = plateOrCard.replace(/[^A-Z0-9]/g, '').toUpperCase();
        
        try {
            const response = await apiClient.get<ApiResponse<VehicleApiData>>(
                API_ENDPOINTS.vehicle(cleanValue),
                token
            );

            if (!response.success || !response.data) {
                return null;
            }

            return new Vehicle(
                response.data.id,
                response.data.placa,
                response.data.serial,
                response.data.idcli,
                response.data.nome
            );
        } catch (error) {
            console.error('Error fetching vehicle:', error);
            return null;
        }
    }
}

